import React from 'react';
import globalStyle from './globalStyle';
export const Typo = () => (<style jsx global>
    {globalStyle}
  </style>);
